// Servizio Analytics — tracking pubblico (fire-and-forget) + letture admin.
import { API, api } from '@/lib/api';

const VISITOR_KEY = 'sila_visitor_id';

// ID visitatore anonimo persistente (per contare i visitatori unici).
export function getVisitorId() {
  try {
    let v = localStorage.getItem(VISITOR_KEY);
    if (!v) {
      v = (crypto?.randomUUID ? crypto.randomUUID() : `v-${Date.now()}-${Math.random().toString(16).slice(2)}`).replace(/-/g, '').slice(0, 24);
      localStorage.setItem(VISITOR_KEY, v);
    }
    return v;
  } catch {
    return '';
  }
}

// Invia una visita in modo NON bloccante (keepalive). Non usa axios per evitare
// interceptor/refresh: il tracking non deve mai impattare l'esperienza pubblica.
export function trackVisit({ path, referrer = '', title = '', utmSource = '' }) {
  try {
    const body = JSON.stringify({
      path,
      referrer: referrer || '',
      title: title || '',
      utm_source: utmSource || '',
      visitor_id: getVisitorId(),
    });
    fetch(`${API}/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
      credentials: 'omit',
    }).catch(() => { /* fail-silent */ });
  } catch { /* noop */ }
}

export const analyticsService = {
  overview: (days = 30) => api.get(`/admin/analytics/overview?days=${days}`).then((r) => r.data),
  live: (limit = 200) => api.get(`/admin/analytics/live?limit=${limit}`).then((r) => r.data),
  feed: (limit = 40) => api.get(`/admin/analytics/feed?limit=${limit}`).then((r) => r.data),
};
